"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserLocation = exports.getBrowserLocationPermission = exports.getLocationData = exports.setLocationData = void 0;

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _dom = require("eventbrite_design_system/utils/dom");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing
var setLocationData = function setLocationData(locationData) {
  if (_dom.HAS_DOCUMENT) {
    _cookiesJs.default.set(_constants.LOCATION_COOKIE, JSON.stringify(locationData), {
      path: '/',
      secure: true
    });
  }
}; // See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing


exports.setLocationData = setLocationData;

var getLocationData = function getLocationData() {
  if (_dom.HAS_DOCUMENT) {
    var locationData = _cookiesJs.default.get(_constants.LOCATION_COOKIE);

    if (locationData) {
      try {
        return JSON.parse(locationData);
      } catch (e) {
        return null;
      }
    }
  }

  return null;
};

exports.getLocationData = getLocationData;

var getBrowserLocationPermission = function getBrowserLocationPermission() {
  var promise;

  if (_dom.HAS_WINDOW && window.navigator && window.navigator.permissions) {
    promise = navigator.permissions.query({
      name: 'geolocation'
    }).then(function (result) {
      return result.state;
    });
  } else {
    promise = new Promise(function (_, reject) {
      return reject('No geolocation permissions object');
    });
  }

  return promise;
};

exports.getBrowserLocationPermission = getBrowserLocationPermission;

var getBrowserLocation = function getBrowserLocation() {
  var promise;

  if (_dom.HAS_WINDOW && window.navigator && window.navigator.geolocation) {
    promise = new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  } else {
    promise = new Promise(function (_, reject) {
      return reject('No geolocation object');
    });
  }

  return promise;
};

exports.getBrowserLocation = getBrowserLocation;
//# sourceMappingURL=location.js.map